<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Text Cursor" class="d-icon d-icon--text-cursor" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M6.94 1.94A1.5 1.5 0 0 1 8 1.5h.5a.5.5 0 1 0 0-1H8a2.5 2.5 0 0 0-2 1 2.5 2.5 0 0 0-2-1h-.5a.5.5 0 0 0 0 1H4A1.5 1.5 0 0 1 5.5 3v6A1.5 1.5 0 0 1 4 10.5h-.5a.5.5 0 0 0 0 1H4a2.5 2.5 0 0 0 2-1 2.507 2.507 0 0 0 2 1h.5a.5.5 0 0 0 0-1H8A1.5 1.5 0 0 1 6.5 9V3c0-.398.158-.78.44-1.06Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconTextCursor',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
